export default "__VITE_ASSET__Cx6vxMK4__"